var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInboxIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 4.66669L8.67271 8.48469C8.4693 8.60283 8.23827 8.66506 8.00304 8.66506C7.76782 8.66506 7.53678 8.60283 7.33337 8.48469L1.33337 4.66669",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3334 2.66669H2.66671C1.93033 2.66669 1.33337 3.26364 1.33337 4.00002V12C1.33337 12.7364 1.93033 13.3334 2.66671 13.3334H13.3334C14.0698 13.3334 14.6667 12.7364 14.6667 12V4.00002C14.6667 3.26364 14.0698 2.66669 13.3334 2.66669Z",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInboxIcon);
export default __webpack_public_path__ + "static/media/inboxIcon.fd7c547a815e785c9f4ae050cd4a5017.svg";
export { ForwardRef as ReactComponent };